import React from "react";
import { Button, Modal } from "antd";

const AppActionModal = ({
  open,
  onCancel,
  title,
  description,
  icon,
  variant = "info",
  primaryAction,
  secondaryAction,
  className = "",
  centered = true,
  closable = true,
  maskClosable = true,
  width,
  children,
}) => {
  const modalClassName = `appActionModal appActionModal--${variant} ${className}`.trim();

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      centered={centered}
      closable={closable}
      maskClosable={maskClosable}
      width={width}
      className={modalClassName}
    >
      <div className="appActionModalContent">
        {icon ? (
          <div className="appActionModalIcon" aria-hidden="true">
            {icon}
          </div>
        ) : null}

        {title ? <h3 className="appActionModalTitle">{title}</h3> : null}
        {description ? (
          <p className="appActionModalText">{description}</p>
        ) : null}
        {children}

        {(secondaryAction || primaryAction) && (
          <div className="appModalActions">
            {secondaryAction ? (
              <Button
                className={`appSecondaryBtn ${secondaryAction.className || ""}`.trim()}
                onClick={secondaryAction.onClick}
                loading={secondaryAction.loading}
                disabled={secondaryAction.disabled}
                danger={secondaryAction.danger}
              >
                {secondaryAction.label}
              </Button>
            ) : null}

            {primaryAction ? (
              <Button
                type="primary"
                className={`appPrimaryBtn ${primaryAction.className || ""}`.trim()}
                onClick={primaryAction.onClick}
                loading={primaryAction.loading}
                disabled={primaryAction.disabled}
                danger={primaryAction.danger}
              >
                {primaryAction.label}
              </Button>
            ) : null}
          </div>
        )}
      </div>
    </Modal>
  );
};

export default AppActionModal;
